import {useLocation} from "react-router-dom";
import Item from "./Item";
import {itemIsActive} from "../../utils/itemIsActive";

export default function AppealsItem() {
  const url = useLocation();

  return (
    <Item
      link={'/appeals'}
      label={'Апелляции'}
      active={itemIsActive(url.pathname, ['/appeals'])}
    />
  );
}